
import {throwError as observableThrowError,  Observable ,  forkJoin } from 'rxjs';

import {refCount, publishReplay, catchError} from 'rxjs/operators';
import { Injectable, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core'
// import { Http, Headers, Response, RequestOptions, URLSearchParams} from '@angular/http'
import { HttpClient, HttpHeaders, HttpResponse, HttpParams} from '@angular/common/http'



import { AuthService } from './auth.service'
import { SharedMethodsModule } from '../insa-custom-scripts/sharedMethods'

import { appStateProvider } from '../insa-providers/AppStateProvider'
import { appConfig } from '../../insaweb.config'
import { LocalizeService } from './localize.service';
import { jsonpFactory } from '@angular/http/src/http_module';

@Injectable()
export class TaskListService implements OnDestroy {

    private language: string = 'en';
    private hostAddress: string = appConfig.insaServiceAddress;
    private servicesURL: string = "/InsaService";

    authServiceSubscription:any;
    stateSubscription:any;

    constructor(private _appStateProvider: appStateProvider, private http: HttpClient, private _authService: AuthService, private _localize: LocalizeService) {
        this.language = this._localize.getLocale().substring(0, 2);
        this.stateSubscription = this._appStateProvider.subscribe(eventdata => this.initDataFetching(eventdata));
        this.authServiceSubscription = this._authService.LoggedInStatusChangedEmitter.subscribe((loggedIn) => {
            if (loggedIn.value === true) {
                this.language = this._localize.getLocale().substring(0, 2);
            } 
        });
    }

    initDataFetching(e) {
        this.language = this._localize.getLocale().substring(0, 2);
    }

    getTaskList() {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        let req = this.http.get(this.hostAddress + this.servicesURL + '/Task'+ '?tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get task.")))
            //.map(res => res.json())
        return req;
    }

    createTask(task: any) {
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(task);
        let req = this.http.post(this.hostAddress + this.servicesURL + '/Task', body, { headers })
            .pipe(
                catchError(err => this.handleError(err, "Could not create task.")))
            //.map(res => res.json())
        return req;
    }

    deleteTask(taskID: string) {
        let headers = this._authService.getAuthHeaders('application/json');

        return this.http.delete(this.hostAddress + this.servicesURL + '/Task?taskID=' + taskID,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not delete task with id " + taskID)))
    }

    updateTask(taskToUpdate: any) {
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(taskToUpdate);

        let req = this.http.put(this.hostAddress + this.servicesURL + '/Task', body, { headers }).pipe(publishReplay(),refCount(),)
            .pipe(
                catchError(err => this.handleError(err, "Could not update task with update ")))
            //.map(res => res.json())
        return req;
    }

    getUsers(){
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();
        
        let req = this.http.get(this.hostAddress + this.servicesURL + '/Users'+ '?tsp=' + timeStamp,
        { headers })
        .pipe(
            publishReplay(),
            refCount(),
            catchError(err => this.handleError(err, "Could not get users ")))
        //.map(res => res.json())

        return req;
    }

    private handleError(error: any, message: string) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
            SharedMethodsModule.addNotification("#notification", message, false); 
        return observableThrowError(errMsg);
    }

    ngOnDestroy() {
        this.stateSubscription.unsubscribe();
        this.authServiceSubscription.unsubscribe();
    }
}










// WEBPACK FOOTER //
// ./app/insa-services/task-list.service.ts